import { useState, useTransition } from "react";
import { toast } from "sonner";
import { adicionarNotaAction } from "@/web/src/acoes";

/** Nota interna: a equipe lê, o paciente nunca. */
export function FormNota({ telefone }: { telefone: string }) {
  const [texto, setTexto] = useState("");
  const [pendente, iniciar] = useTransition();
  return (
    <form
      className="flex flex-col gap-2"
      onSubmit={(e) => {
        e.preventDefault();
        if (!texto.trim()) return;
        iniciar(async () => {
          const r = await adicionarNotaAction(telefone, texto);
          if (!r.ok) toast.error(r.erro);
          else setTexto("");
        });
      }}
    >
      <textarea
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        rows={2}
        disabled={pendente}
        placeholder="Anotação para a equipe — o paciente não vê"
        aria-label="Nova nota para a equipe"
        className="w-full resize-none rounded-[10px] border border-[var(--color-borda)] bg-[var(--color-painel)] px-3 py-2 text-[13px] text-[var(--color-tinta)] outline-none transition-colors placeholder:text-[var(--color-fraco)] focus:border-[var(--color-marca)] focus:bg-[var(--color-cartao)]"
      />
      <button
        type="submit"
        disabled={pendente || !texto.trim()}
        className="h-8 self-end rounded-full bg-[var(--color-cartao)] px-3.5 text-[13px] font-semibold text-[var(--color-tinta)] shadow-botao transition-colors hover:bg-[var(--color-painel)] disabled:opacity-40"
      >
        {pendente ? "Anotando…" : "Anotar"}
      </button>
    </form>
  );
}
